import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';

const featuredIconVariants = cva('flex items-center justify-center shrink-0', {
  variants: {
    size: {
      xs: 'size-6 rounded-sm',
      sm: 'size-8 rounded-sm',
      md: 'size-10 rounded-md',
      lg: 'size-12 rounded-lg',
      xl: 'size-14 rounded-xl',
    },
    variant: {
      violet: 'bg-utility-violet-50',
      'gray-light': 'bg-bg-tertiary',
      'gray-modern': 'bg-bg-primary border border-primary',
      error: 'bg-utility-error-50',
      warning: 'bg-utility-warning-50',
      success: 'bg-utility-success-50',
      orange: 'bg-utility-orange-50',
      blue: 'bg-utility-blue-50',
      gray: 'bg-bg-secondary',
    },
  },
  defaultVariants: {
    size: 'md',
    variant: 'gray-modern',
  },
});

const iconVariants = cva('text-fg-primary', {
  variants: {
    variant: {
      violet: 'text-utility-violet-600',
      'gray-light': 'text-fg-secondary',
      'gray-modern': 'text-fg-secondary',
      error: 'text-utility-error-600',
      warning: 'text-utility-warning-600',
      success: 'text-utility-success-600',
      orange: 'text-utility-orange-600',
      blue: 'text-utility-blue-600',
      gray: '!text-fg-brand',
    },
    size: {
      xs: 'size-3',
      sm: 'size-4',
      md: 'size-5',
      lg: 'size-6',
      xl: 'size-7',
    },
  },
  defaultVariants: {
    variant: 'gray-modern',
    size: 'md',
  },
});

interface FeaturedIconProps extends VariantProps<typeof featuredIconVariants> {
  icon: React.JSX.Element;
}

const FeaturedIcon = ({
  icon,
  size = 'md',
  variant = 'gray-modern',
}: FeaturedIconProps) => {
  return (
    <div className={featuredIconVariants({ size, variant })}>
      {React.cloneElement(icon, {
        className: iconVariants({ size, variant }),
      })}
    </div>
  );
};

export default FeaturedIcon;
